export { TeachingPopoverHeader } from './TeachingPopoverHeader';
export { useTeachingPopoverHeader } from './useTeachingPopoverHeader';
export { renderTeachingPopoverHeader } from './renderTeachingPopoverHeader';
export type {
  TeachingPopoverHeaderProps,
  TeachingPopoverHeaderSlots,
  TeachingPopoverHeaderState,
} from './TeachingPopoverHeader.types';
